import { Box, Typography } from '@mui/material'
import React from 'react'
import { colors } from '../../theme'
import image from './images/featureTitleShape.png'

interface Props {
  title: string
  children: React.ReactNode
}

export const FeaturesList: React.FC<Props> = ({ title, children }) => {
  return (
    <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '6px' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 0.75, md: 1 },
          mt: '20px',
          mb: '10px',
        }}
      >
        <img
          src={image}
          alt="Abstract form to add nice design"
          width={39}
          height={39}
          style={{ position: 'relative', zIndex: 0, alignSelf: 'center' }}
        />
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: { xs: 16, md: 18 },
            color: colors.blue,
            position: 'relative',
            zIndex: 1,
            whiteSpace: { xs: 'normal', md: 'nowrap' },
            lineHeight: { xs: 1.2, md: 1.1 },
            m: 0,
            maxWidth: { xs: '90%', md: '100%' },
            textAlign: 'left',
          }}
        >
          {title}
        </Typography>
      </Box>
      {children}
    </Box>
  )
}
